import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import { CLI, FEATURES, FRONT, PROGRAM_CINEMAS, PROGRAM_MOVIES_ITEMS, PROGRAM_MOVIES_ORDER, THEME, TRANSLATION } from '../constants/state'
import PageOverviewSignage from './PageOverviewSignage'
import getData from '../functions/getData'

const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT),
    movies: getData(state, PROGRAM_MOVIES_ITEMS),
    moviesOrder: getData(state, PROGRAM_MOVIES_ORDER),
    features: getData(state, FEATURES),
    theme: getData(state, THEME),
    translation: getData(state, TRANSLATION),
    cinemas: getData(state, PROGRAM_CINEMAS),
    cliData: getData(state, CLI)
})

const PageOverviewSignageContainer = ({
    movies,
    moviesOrder,
    cinemaDataFront,
    features,
    theme,
    cliData,
    cinemas,
    translation,
    match,
    location
}) => (
    <PageOverviewSignage
        movies={movies}
        moviesOrder={moviesOrder}
        cinemaDataFront={cinemaDataFront}
        match={match}
        location={location}
        features={features}
        theme={theme}
        cliData={cliData}
        cinemas={cinemas}
        translation={translation}
    />
)

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(PageOverviewSignageContainer)

